// extracted by mini-css-extract-plugin
module.exports = {"numbers":"HeroBannerPromoCountdown_numbers__2USPN","text":"HeroBannerPromoCountdown_text__Aiopz"};